module.exports = __webpack_public_path__ + "img/appSafe.45ac00f2.png";